import { StrictEqualityComparer } from "../../shared/index.js";
export const contains = (source, value, comparer = StrictEqualityComparer) => {
    for (const item of source) {
        if (comparer(value, item)) {
            return true;
        }
    }
    return false;
};
